"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var EButtonTypes;
(function (EButtonTypes) {
  EButtonTypes["Main"] = "main";
  EButtonTypes["Additional"] = "additional";
  EButtonTypes["Comparison"] = "comparison";
  EButtonTypes["CopyProductUrl"] = "copyProductUrl";
})(EButtonTypes || (EButtonTypes = {}));
var _default = EButtonTypes;
exports.default = _default;